module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-func "
  }, [_c('div', {
    attrs: {
      "id": "hrms17e-detail1"
    }
  }, [(_vm.detail1Disp) ? [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row margin-b-5"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EC2']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setYearOutput(_vm.searchIndex.year)))])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EC2']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.searchIndex.numtime))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EC2']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('hrms-lov', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "lovType": "codempid",
      "nowLang": _vm.nowLang,
      "name": "codempid",
      "disabled": _vm.eventBtn === 'edit',
      "descDisp": true,
      "desc": _vm.descCodempid,
      "has-error": _vm.errors.has('codempid')
    },
    model: {
      value: (_vm.codempid),
      callback: function($$v) {
        _vm.codempid = $$v
      },
      expression: "codempid"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codempid')),
      expression: "errors.has('codempid')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codempid')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b-5"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EC2']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.codcomp) + " - " + _vm._s(_vm.desc_codcomp))])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b-5"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EC2']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.codpos) + " - " + _vm._s(_vm.desc_codpos))])])])]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.detail1Table,
      "data": _vm.detail1,
      "detail1Selected": _vm.detail1Selected,
      "addEvent": _vm.addEvent,
      "editEvent": _vm.editEvent,
      "deleteInlineEventBool": true,
      "deleteInlineBtnDisp": false,
      "saveInlineEvent": _vm.deleteEvent,
      "nowLang": _vm.nowLang
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])] : [_c('detail2', {
    attrs: {
      "dataHeader": _vm.dataHeader,
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "maxRowspan": _vm.maxRowspan,
      "detail": _vm.detail2,
      "nowLang": _vm.nowLang,
      "toggle": _vm.toggle,
      "inlineDetail2Tab1": _vm.inlineDetail2Tab1,
      "inlineDetail2Tab2": _vm.inlineDetail2Tab2,
      "detail2Tab1Table": _vm.detail2Tab1Table,
      "detail2Tab2Table": _vm.detail2Tab2Table,
      "indexSelected": _vm.indexSelected,
      "searchIndex": _vm.searchIndex,
      "detail1Selected": _vm.detail1Selected,
      "setInlineDetail2Tab1": _vm.setInlineDetail2Tab1,
      "setInlineDetail2Tab2": _vm.setInlineDetail2Tab2,
      "postDetail2Save": _vm.postDetail2Save,
      "dropdowns": _vm.dropdowns
    }
  })]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30d86e4e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms17e/detail1.vue
// module id = 3669
// module chunks = 1